module.exports = __webpack_public_path__ + "0b851928dc54c2b792b4040970da0e89.svg";